module.exports = __webpack_public_path__ + "static/home_2-75607a84698df701156446a1caa91211.png";